import React from 'react'
import { useSearchParams } from 'react-router-dom'
import PasswordResetForm from './PasswordResetForm'
import bgImg from '../../assets/img/generic/20.jpg'
import SplitPageLayout from '../_layout/SplitPageLayout'
import { useLazyCheckActivationAccountQuery } from '../../store/kopiliot-api/auth'

const ActivateAccount = () => {
  const [check, result] = useLazyCheckActivationAccountQuery()
  const [searchParams] = useSearchParams()
  React.useEffect(() => {
    const token = searchParams.get('activation_token')
    if (token) {
      check({ activation_token: token })
    }
  }, [searchParams])
  const showSuccess = () => {
    if (!result.isLoading && !result.error) {
      return (
        <PasswordResetForm
          token={searchParams.get('activation_token')}
          title="Activer votre compte"
          action="activate"
        />
      )
    }
  }
  return (
    <SplitPageLayout bgProps={{ image: bgImg }}>
      <div className="container-fluid">
        <h3 className="text-center">Activer votre compte</h3>
      </div>
      {showSuccess()}
    </SplitPageLayout>
  )
}

export default ActivateAccount
